import { Widget } from '@typeform/embed-react'

function TFForm() {
    return (
    <div id="typeform-container" className='card w-100 mx-auto pb-3'>
        <div id='typeform-header' className='card-header text-center d-flex align-items-center'>
            <h5 id='header-claim' className='mx-auto text-center fs-4'>Claim Your FREE $5 Amazon Gift Card*</h5>
        </div>
        <div className='card-body'>
            <Widget id="TrQzSYh3" style={{width: '90%', height: '100%', opacity: '1', autoResize: 'true'}} className="Meg & Hugo Lander mx-auto" autoResize="true" />
        </div>
        <div id='typeform-footer' className='text-light card-footer text-center'>
            *Offer limited to existing customers.
        </div>
    </div>
    );
}
export default TFForm